import styled from 'styled-components';
import { CarOptionStyled } from '../CarOptionStyled';
import { rem } from 'polished';

export const CarOptionStyledDS = styled(CarOptionStyled)`
    border-radius: ${rem(8)};
    border-color: ${({ theme }) => theme.colors.grey16};

    .inner {
        border-radius: ${rem(5)};
    }

    &.isSelected {
        background: ${({ theme }) => theme.colors.grey4};
        border-color: ${({ theme }) => theme.colors.primary};
        .inner {
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .option-card {
        &__name,
        &__detailLink {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            color: ${({ theme }) => theme.colors.black};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
        &__add-priceWrapper {
            font-size: ${({ theme }) => theme.fontSizes.h6};
            color: ${({ theme }) => theme.colors.black};
        }
        &__detailDescription {
            line-height: ${rem(18)};
        }
    }
`;
